import React from 'react';
import { formatPhoneNumber } from '@/utils/helpers';

const Phone = ({ children }: { children: React.ReactChild }) => {
  return <>{formatPhoneNumber(children as string)}</>;
};

export default Phone;
